import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-valuenow"]
const _hoisted_2 = {
  key: 0,
  class: "el-progress-bar"
}
const _hoisted_3 = {
  key: 0,
  class: "el-progress-bar__innerText"
}
const _hoisted_4 = { viewBox: "0 0 100 100" }
const _hoisted_5 = ["d", "stroke-width"]
const _hoisted_6 = ["d", "stroke", "stroke-linecap", "stroke-width"]
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["el-progress ms-progress", [
      `el-progress--${_ctx.type}`,
      _ctx.status ? `is-${_ctx.status}` : '',
      {
        'el-progress--without-text': !_ctx.showText,
        'el-progress--text-inside': _ctx.textInside,
      }
    ]]),
    role: "progressbar",
    "aria-valuenow": _ctx.percentage,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  }, [
    (_ctx.type === 'line')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "el-progress-bar__outer",
            style: _normalizeStyle({height: `${_ctx.strokeWidth}px`})
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
            'el-progress-bar__inner',
            { 'el-progress-bar__inner--indeterminate' : _ctx.indeterminate }
          ]),
              style: _normalizeStyle(_ctx.barStyle)
            }, [
              ((_ctx.showText || _ctx.$slots.default) && _ctx.textInside)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_ctx.slotData)), () => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.content), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 6)
          ], 4)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "el-progress-circle",
          style: _normalizeStyle({height: `${_ctx.width}px`, width: `${_ctx.width}px`})
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_4, [
            _createElementVNode("path", {
              class: "el-progress-circle__track",
              d: _ctx.trackPath,
              stroke: "#e5e9f2",
              "stroke-width": _ctx.relativeStrokeWidth,
              fill: "none",
              style: _normalizeStyle(_ctx.trailPathStyle)
            }, null, 12, _hoisted_5),
            _createElementVNode("path", {
              class: "el-progress-circle__path",
              d: _ctx.trackPath,
              stroke: _ctx.stroke,
              fill: "none",
              "stroke-linecap": _ctx.strokeLinecap,
              "stroke-width": _ctx.percentage ? _ctx.relativeStrokeWidth : 0,
              style: _normalizeStyle(_ctx.circlePathStyle)
            }, null, 12, _hoisted_6)
          ]))
        ], 4)),
    ((_ctx.showText || _ctx.$slots.default) && !_ctx.textInside)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "el-progress__text",
          style: _normalizeStyle({fontSize: `${_ctx.progressTextSize}px`})
        }, [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_ctx.slotData)), () => [
            (!_ctx.status)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.content), 1))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: _normalizeClass(_ctx.iconClass)
                }, null, 2))
          ])
        ], 4))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}